<template>
  <v-container
    class="align-content-start"
    fill-height
    fluid
  >
    <v-row>
      <section-header
        :breadcrumb-items="breadcrumb"
      />
    </v-row>

    <v-row style="height: calc(100% - 70px);">
      <v-col cols="12">
        <v-container
          class="align-content-start"
          fill-height
          fluid
          pa-0
        >
          <v-row
            justify="space-between"
          >
            <v-col cols="6">
              <v-tabs
                v-model="activeTab"
                active-class="active-tab"
                background-color="transparent"
                height="30"
                hide-slider
                show-arrows
              >
                <v-tab>
                  {{ $t('PastAnalyses.Tab.PastAnalyses.Title') }}
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col
              cols="12"
              lg="4"
              md="6"
            >
              <v-text-field
                v-model="searchTerms"
                :placeholder="$t('Common.Search.Title')"
                background-color="white"
                dense
                height="28"
                hide-details="auto"
                outlined
                clearable
                prepend-inner-icon="mdi-magnify"
              />
            </v-col>
          </v-row>

          <v-row class="fill-height">
            <v-col
              class="pa-0"
              cols="12"
            >
              <v-tabs-items
                v-model="activeTab"
                class="fill-height"
              >
                <v-tab-item>
                  <past-analyses-list
                    :search-terms="searchTerms"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>

import i18nRouteMeta        from '@/mixins/i18n/i18nRouteMeta'
import SectionHeader        from '@/theme/default/components/common/SectionHeader'
import Auth                 from '@/mixins/auth'
import PastAnalysesList from '@/theme/default/views/banking/risk/interest-rate/past-analyses/PastAnalysesList'
import routerTabState       from '@/mixins/routerTabState'

export default {
  name      : 'PastAnalyses',
  components: {
    PastAnalysesList,
    SectionHeader
  },
  mixins: [Auth, i18nRouteMeta, routerTabState],
  data () {
    return {
      searchTerms: ''
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('Route.Risks.Title'),
        disabled: true
      }]
    }
  }
}
  </script>

  <style scoped>
  ::v-deep .v-window__container,
  ::v-deep .v-window-item {
    height: 100% !important;
  }
  </style>
